export const UPDATE_NCB = 'carInsurance/UPDATE_NCB';
export const UPDATE_VEHICLE_FILTER_DATA = 'carInsurance/UPDATE_VEHICLE_FILTER_DATA';
export const UPDATE_ADDONS = 'carInsurance/UPDATE_ADDONS';
export const UPDATING_QUOTE = 'carInsurance/UPDATING_QUOTE';
export const UPDATE_IDV = 'carInsurance/UPDATE_IDV';

export const SET_PROPOSAL_DETAILS = 'carInsurance/SET_PROPOSAL_DETAILS';
export const RESET_INSURANCE = 'carInsurance/RESET_INSURANCE';
export const SET_REQUEST_ID = 'carInsurance/SET_REQUEST_ID';
export const SET_QUOTES_PAYLOAD = 'carInsurance/SET_QUOTES_PAYLOAD';
export const SET_ACTIVE_TAB = 'carInsurance/SET_ACTIVE_TAB';
